// import hooks
import Cookies from "js-cookie";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize, {useWindowHeight} from "../utils/custom-hooks/useWindowSize";

// import components
import Nav from "./Nav/Nav";
import Main from "./Main/Main";
import Footer from "./Footer";
import Product from "./Product/Product";
import EmptyCart from "./Cart/EmptyCart";
import Cart from "./Cart/Cart";
import ProductsPage from "./ProductsPage";
import CompleteOrder from "./Cart/CompleteOrder";
import Paragraph from "./Paragraph";
import Account from "./Account/Account";
import PersonalInfo from "./Account/PersonalInfo";

import Orders from "./Account/Orders";
import OrderSummary from "./Account/OrderSummary";
import WishList from "./Account/WishList";

import { Route, Routes } from "react-router-dom";


// import assets
import "../assets/css/ui.css";

// import data
import { user, order, orders, items } from "../utils/data/accountData";

function App() {
    const [colorMode, setColorMode] = useState(null);
    const windowWidth = useWindowSize();
    const windowHeight = useWindowHeight();
    const [, i18n] = useTranslation("global");
    const appRef = useRef();
    const footerRef = useRef();
    const [appHeight, setAppHeight] = useState(0);
    const [footerHeight, setFooterHeight] = useState(0);
    // const [newAppH, setNewAppH] = useState(0);
    const [stickyFooter, setStickyFooter] = useState(false)
    const handleChangeLang = (lang) => {
        i18n.changeLanguage(lang);
    };

    const changeColorMode = () => {
        const color = colorMode == "light" ? "dark" : "light";
        setColorMode(color);
    };

    useEffect(() => {
        setAppHeight(appRef.current.clientHeight);
        setFooterHeight(footerRef.current.clientHeight);
        setStickyFooter(windowHeight-appHeight>0);
        // console.log(`window height: ${windowHeight}`)
        // console.log(`app height: ${appHeight}`)
        // console.log(`add sticky to footer: ${windowHeight-appHeight>0?"true":"false"}`)
    });

    useEffect(() => {
        let tempLang = Cookies.get("lang");
        if (!tempLang) {
            (tempLang = "ar"), Cookies.set("lang", "ar");
        }
        handleChangeLang(tempLang);

        if (!colorMode) {
            let tempColorMode = Cookies.get("mode");
            if (!tempColorMode) {
                tempColorMode = "dark";
                Cookies.set("mode", "dark");
            }
            setColorMode(tempColorMode);
        }
    }, []);

    return (
        <div
            className={`App ${colorMode} ${i18n.language} ${
                windowWidth >= 992 ? "lgView" : "smView"
            } ${stickyFooter?"sticky-app":""}`}
            style={stickyFooter?({minHeight: `${windowHeight-footerHeight}px`}):{}}
            ref={appRef}
        >
            <Nav
                lang={i18n.language}
                view={windowWidth >= 992 ? "lgView" : "smView"}
                mode={colorMode}
                changeLang={handleChangeLang}
                changeColorMode={changeColorMode}
            />
            <Routes>
                <Route path="/" element={<Main />}/>
                <Route path="/product" element={<Product />}/>
                <Route path="/cart-empty" element={<EmptyCart />}/>
                <Route path="/cart" element={<Cart />}/>
                <Route path="/complete-order" element={<CompleteOrder />}/>
                <Route path="/search" element={<ProductsPage/>}/>
                <Route path="/about-us" element={<Paragraph/>}/>
                <Route path="/account" element={<Account />}/>
                <Route path="/user" element={<PersonalInfo />}/>
                <Route path="/orders" element={<Orders items={orders} />}/>
                <Route path="/order-summary" element={<OrderSummary items={items} name={user.name} order={order} />}/>
                <Route path="/wishlist" element={<WishList name={user.name} items={items} />}/>
            </Routes>
            <div className={`${stickyFooter?"sticky-footer":""}`} ref={footerRef}>
                <Footer />
            </div>
                
        </div>
    );
}

export default App;
